"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeI18n = void 0;
var i18next_1 = __importDefault(require("i18next"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var useUser_1 = __importDefault(require("../hooks/useUser"));
var fallbackLanguage = 'en';
var buildConfig = function (options) {
    var _a;
    return (__assign({ lng: 'en', 
        // we do not use keys in form messages.welcome
        keySeparator: false, interpolation: {
            prefix: '{',
            suffix: '}',
            // react already handles xss
            escapeValue: false,
        }, react: {
            useSuspense: false,
        }, fallbackLng: 'en', defaultNS: options.namespace }, ((options === null || options === void 0 ? void 0 : options.defaultStrings) && {
        resources: {
            en: (_a = {}, _a[options.namespace] = options.defaultStrings, _a),
        },
    })));
};
var useUpdateLanguage = function (translationUri, namespace) {
    var user = (0, useUser_1.default)(), language = user === null || user === void 0 ? void 0 : user.language;
    (0, react_1.useEffect)(function () {
        var defaultLanguage = language !== null && language !== void 0 ? language : fallbackLanguage;
        if (!i18next_1.default.isInitialized)
            return;
        var url = new URL("t/".concat(namespace), translationUri);
        fetch(url.href, {
            headers: { 'accept-language': defaultLanguage },
        })
            .then(function (res) {
            if (res.ok)
                return res.json();
            throw res;
        })
            .then(function (data) {
            i18next_1.default.addResourceBundle(defaultLanguage, namespace, data);
        })
            .catch(function (error) {
            console.error('Unable to retrieve translation data:', error.message);
        });
    }, [language, translationUri, namespace]);
};
var initializeI18n = function (options) {
    i18next_1.default
        .use(react_i18next_1.initReactI18next) // passes i18n down to react-i18next
        .init(buildConfig(options));
};
exports.initializeI18n = initializeI18n;
var TranslationLoader = function (_a) {
    var children = _a.children, namespace = _a.namespace, defaultStrings = _a.defaultStrings, translationUri = _a.translationUri;
    var user = (0, useUser_1.default)();
    var language = user === null || user === void 0 ? void 0 : user.language;
    (0, react_1.useEffect)(function () {
        i18next_1.default.addResourceBundle('en', namespace, defaultStrings);
    }, [namespace, defaultStrings]);
    (0, react_1.useEffect)(function () {
        i18next_1.default.changeLanguage(language);
    }, [language]);
    useUpdateLanguage(translationUri, namespace);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = TranslationLoader;
//# sourceMappingURL=TranslationLoader.js.map